import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getFeedback = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/api/contactpointandsubsfb/${clientId}/list/`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sendFeedback = (data) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .post('/feedbacks/', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getFeedback, sendFeedback }
